import * as PIXI from "pixi.js";
import BaseButton from "./BaseButton";
import { ButtonBounds } from "../../types/Interface";
import { ButtonStatus,  Sounds } from "../../types/Enum";


export default class PlayButton extends BaseButton {
  isVertical = false;
  constructor(bounds: ButtonBounds, isVertical: boolean) {
    super("play", Sounds.click3);
    Object.assign(this, bounds);

    this.isVertical = isVertical;
    this.hitArea = new PIXI.Circle(0, 0, bounds.width - 8)
    this.EventBus.on(this.EnumEventBus.setPlayButStatus, (value: ButtonStatus) => this.setButton(value));
  }

  handlePress() {
    this.setAvaible(false);
    this.EventBus.emit(this.EnumEventBus.setAPlayButStatus, ButtonStatus.semiOpacity);
    this.EventBus.emit(this.EnumEventBus.spin, false);
  }
  setButton(value: ButtonStatus) {
    if (value == ButtonStatus.semiOpacity) {
      this.setAvaible(false);
    }
    else if (value == ButtonStatus.show) {
      this.setAvaible(true);
      this.setVisible(true);
    }
    else if (value == ButtonStatus.hide) {
      this.setAvaible(false);
      this.setVisible(false);
    }
  }
  setAvaible(value: boolean) {
    this.alpha = value ? 1 : .5;
    this.setInteractivity(value)
  }
  setInteractivity(v: boolean) {
    this.interactive = v;
  }
  setVisible(value: boolean) {
    this.visible = value;
    this.exchangeTexture(this.regular);
  }
}